import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getProjectDocumentVersionFileAnnotation,
  getProjectDocumentVersionFileAnnotationLink,
  getProjectDocumentVersionFileInfo,
  getProjectDocumentVersionFilePreview,
  getProjectDocumentVersionFileWithWaterMark
} from '../../api/project-document-version-files';
import { getProjectDocumentRevisionFileAsync } from '../ProjectDocumentRevisionFile/projectDocumentRevisionFileSlice';

export const getProjectDocumentVersionFileOnlyAsync = createAsyncThunk(
  'projectDocumentVersionFile/getProjectDocumentVersionFileOnly',
  getProjectDocumentVersionFileWithWaterMark
);

export const getProjectDocumentVersionFilePreviewAsync = createAsyncThunk(
  'projectDocumentVersionFile/getProjectDocumentVersionFilePreview',
  getProjectDocumentVersionFilePreview
);

export const getProjectDocumentVersionFileAsync = createAsyncThunk(
  'projectDocumentVersionFile/getProjectDocumentVersionFile',
  async (projectDocumentVersionFileId: number, thunkAPI) => {
    const projectDocumentVersionFile = await getProjectDocumentVersionFileInfo(
      projectDocumentVersionFileId
    );
    thunkAPI.dispatch(
      getProjectDocumentRevisionFileAsync(
        projectDocumentVersionFile.projectDocumentRevisionFileId
      )
    );
    return projectDocumentVersionFile;
  }
);

export const getProjectDocumentVersionFileAnnotationLinkAsync =
  createAsyncThunk(
    'projectDocumentVersionFile/getProjectDocumentVersionFileAnnotationLink',
    getProjectDocumentVersionFileAnnotationLink
  );

export const getProjectDocumentVersionFileAnnotationAsync = createAsyncThunk(
  'projectDocumentVersionFile/getProjectDocumentVersionFileAnnotation',
  getProjectDocumentVersionFileAnnotation
);

export enum ActionNameLabel {
  download = 'Download',
  upload = 'Upload',
  preview = 'Preview',
  onlineReview = 'Online Review'
}

export interface ProjectDocumentVersionFile {
  id: number;
  versionNo: number;
  annotation: { id: number; annotationFileId: number } | null;
  createdAt: Date;
  projectDocumentRevisionFileId: number;
  projectDocumentVersionFileLogs: ProjectDocumentVersionFileLog[];
}

export interface ProjectDocumentVersionFileLog {
  id: number;
  firstName: string;
  lastName: string;
  actionName: ActionNameLabel;
  createdAt: Date;
}

interface ProjectDocumentVersionFileState {
  selectedProjectDocumentVersionFile: ProjectDocumentVersionFile | null;
}

const initialState: ProjectDocumentVersionFileState = {
  selectedProjectDocumentVersionFile: null
};

export default createSlice({
  name: 'projectDocumentVersionFiles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getProjectDocumentVersionFileAsync.fulfilled,
      (state, action) => {
        state.selectedProjectDocumentVersionFile = action.payload;
      }
    );
  }
});
